export const LANG_ORDER = [
  'Spanish',
  'French',
  'German',
  'Chinese',
  'Japanese',
  'Korean',
  'Portuguese',
  'Italian',
  'Russian',
  'Arabic',
  'Hebrew',
  'Hindi',
  'Bengali',
  'Hungarian',
  'Romanian'
] as const;
